import PropTypes from "prop-types";

function RoleCell({ role, ...restProps }) {
  return (
    <div
      role="button"
      className="flex flex-1 flex-row justify-center"
      {...restProps}
    >
      {role ? (
        <p className="font-semibold capitalize">{role}</p>
      ) : (
        <div
          className="
            py-2
            px-4
            mx-auto
            text-xs
            normal-case
            text-center
            font-semibold
            bg-light-gray
            text-gray-500
          "
        >
          Unassigned
        </div>
      )}
    </div>
  );
}

RoleCell.propTypes = {
  advisor: PropTypes.shape(),
};

export default RoleCell;
